import "./PublicationSearchPage.scss";
import ContentSearch from "../../Shared/Contentsearch/ContentSearch";
import { PublicationSearchPageProps } from "/App.GeneratedTypes";
import { HeroBasic } from "/App.Components";
import { createSpreadableBem } from "../../../Helpers/createBem";

const PublicationSearchPage = ({
  pageHeader,
  insightSearchBlock,
}: PublicationSearchPageProps) => {
  const bem = createSpreadableBem("publication-search-page-norad");
  return (
    <div {...bem("")}>
      {pageHeader && <HeroBasic {...pageHeader} theme="insight" />}
      {insightSearchBlock && (
        <ContentSearch
          insightSearchBlock={insightSearchBlock}
          publicationSearch
        />
      )}
    </div>
  );
};

export default PublicationSearchPage;
